import {lazy} from "react";

// project imports
import Loadable from "components/Loadable";
import DashboardLayout from "layout/Dashboard";
import ProtectedRoute from "../layout/ProtectedRoute";

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import("../pages/dashboard/default")),);
const Canvas = Loadable(lazy(() => import("../pages/canvas/./CanvasEditor")));
const QrPage = Loadable(lazy(() => import("../pages/qr/default")));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: "/",

    element: <ProtectedRoute><DashboardLayout/></ProtectedRoute>,
    children: [
        {
            path: "/",
            element: <DashboardDefault/>,
        },
        {
            path: "dashboard",
            element: <DashboardDefault/>,
        },
        {
            path: "canva",
            element: <Canvas/>,
        },
        {
            path: "qr",
            element: <QrPage/>,
        },
    ],
};

export default MainRoutes;
